import OrgTeamRole from '@/orm/models/OrgTeamRole'
import { Defaults, Options } from '@/orm/models/Setting'
import SettingsRepo from '@/orm/repositories/SettingsRepo'
import { AxiosRepository } from '@pinia-orm/axios'
import { useRepo } from 'pinia-orm'

export default class OrgTeamRolesRepo extends AxiosRepository<OrgTeamRole> {
    use = OrgTeamRole

    orderedList() {
        return this.all().map((role) => ({ label: role.role, value: role.id }))
            .sort((a, b) => {
                const roleA = useRepo(OrgTeamRole).find(a.value)
                const roleB = useRepo(OrgTeamRole).find(b.value)
                return (roleB?.order ?? 0) - (roleA?.order ?? 0) || a.label.localeCompare(b.label)
            })
    }

    update() {
        const authToken = useRepo(SettingsRepo).getOption(Options.AuthToken, Defaults.AuthToken)

        this.flush()

        return this.api().get('/catalogs/orgRoles', {
            headers: { Authorization: authToken.length > 0 ? 'Bearer ' + authToken : '' },
            dataTransformer: ({ data }) => {
                return data.map((line) => ({
                    id: parseInt(line.id),
                    role: String(line.title.cs),
                    shortcut: (Object.hasOwn(line, 'shortcut') && Object.hasOwn(line.shortcut, 'cs'))
                        ? String(line.shortcut.cs)
                        : undefined,
                    points: Object.hasOwn(line, 'points') ? parseFloat(line.points) : 1.0,
                }))
            },
        })
    }
}
